import { RadioButtonGroup } from "@circle-react-shared/RadioButtonGroup";
import { useState } from "react";

import { t } from "@/i18n-js/instance";
import { ConfirmationModal } from "@/react/components/SettingsApp/CompassCompat/ConfirmationModal";

import type { RecurringEditMode } from "../helpers/constants";
import { RECURRING_EDIT_MODE } from "../helpers/constants";

interface DeleteRecurringModalProps {
  isDeleting?: boolean;
  onCloseModal: () => void;
  onConfirm: (frequency: RecurringEditMode) => void;
  show?: boolean;
}

export const DeleteRecurringModal = ({
  show = false,
  onConfirm,
  onCloseModal,
  isDeleting = false,
}: DeleteRecurringModalProps) => {
  const [selectedFrequency, setSelectedFrequency] =
    useState<RecurringEditMode>();

  const onRadioChangeHandler = (value: RecurringEditMode) => {
    setSelectedFrequency(value);
  };

  const onConfirmHandler = () => {
    if (selectedFrequency) {
      onConfirm(selectedFrequency);
    }
  };

  return (
    <ConfirmationModal
      title={t("events.delete.recurring_event_modal.title")}
      isOpen={show}
      confirmText={
        isDeleting
          ? t("deleting")
          : t("events.delete.recurring_event_modal.accept")
      }
      cancelText={t("events.delete.recurring_event_modal.cancel")}
      onClose={onCloseModal}
      onCancel={onCloseModal}
      onConfirm={onConfirmHandler}
      disabled={isDeleting}
      confirmVariant="danger"
      size="sm"
      modalBodyClassName="mt-6"
    >
      <RadioButtonGroup
        defaultChecked={RECURRING_EDIT_MODE.CURRENT}
        name="recurring_event_settings.frequency_edit"
        options={[
          {
            label: t("events.delete.recurring_event_modal.this_event"),
            value: RECURRING_EDIT_MODE.CURRENT,
          },
          {
            label: t("events.delete.recurring_event_modal.this_and_following"),
            value: RECURRING_EDIT_MODE.REMAINING,
          },
          {
            label: t("events.delete.recurring_event_modal.all_events"),
            value: RECURRING_EDIT_MODE.ALL,
          },
        ]}
        size="sm"
        onChange={onRadioChangeHandler}
      />
    </ConfirmationModal>
  );
};
